import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { LinkCover } from "./link-cover";
import { linksFrom } from "./link-preview-links";

/**
 * A link (mockup `.cover`, Proposed): its first link's cover only
 * (`LinkCover`). The card's label names the page.
 */
export function LinkPreviewCardPreview(props: CardPreviewProps) {
  const link = linksFrom(props.source)[0];
  if (!link) return <GenericCardPreview {...props} />;
  return <LinkCover link={link} density={props.density} />;
}
